import React from "react";
import { Card, Row, Col, Icon, Alert, Empty, Tag, Spin } from "antd";
import { ContentEffectivenessAnalysis, ContentOpportunity } from "../types";

const { Meta } = Card;
type Props = {
    industryNiche: string | undefined;
    summary: string | undefined;
    analysis: ContentEffectivenessAnalysis[] | undefined;
    contentOpportunities: ContentOpportunity[] | undefined;
    inProgress: boolean;
}


export default function ContentEffectivenessReport({ inProgress, industryNiche, summary, analysis, contentOpportunities }: Props) {
    return (
        <Card
            className="content-effectiveness-report"
            type="inner"
            title={
                <Meta
                    title={"AI Content Effectiveness Report"}
                    description={"How well the domain's content addresses the topics users might ask about"}
                />
            }
            extra={inProgress ? <Tag color="orange">Analysis in progress <Spin indicator={<Icon type="loading-3-quarters" spin style={{ fontSize: "12px", marginLeft: "6px" }} />} /></Tag> : null}
        >
            {inProgress && (<Empty description="" />)}
            {!inProgress && !industryNiche && !summary && !analysis && !contentOpportunities && (<Empty description="No content effectiveness report available" />)}
            {(!inProgress && summary && industryNiche && analysis && contentOpportunities) && (
                <>
                    <h4>Overview</h4>
                    <div className="overview" dangerouslySetInnerHTML={{ __html: summary }} />

                    <Alert
                        message={
                            <span>
                                The <strong>Content Effectiveness Analysis</strong> measures how well the website's content addresses the key questions and needs of its target audience within its niche: <strong>{industryNiche}</strong>.
                                By evaluating strengths, weaknesses, and opportunities for improvement against each top user question, it provides a clear picture of the site's effectiveness in delivering relevant,
                                reliable, and actionable information.
                            </span>
                        }
                        type="info"
                        showIcon
                    />

                    <Row gutter={36} style={{ marginTop: "24px" }}>
                        <Col span={14} className="analysis-col">
                            <h4>Top User Questions</h4>
                            <div className="analysis">
                                {analysis.map((section, index) => (
                                    <div key={index} className="analysis-section">
                                        <div className="question">{`Q${index + 1}: ${section.question}`}</div>

                                        <ul>
                                            {section.findings.map((finding, idx) => (
                                                <li key={idx} className={`finding ${finding.type.toLowerCase()}`}>

                                                    {finding.type === "STRENGTH" && <Icon type="check-square" theme="filled" />}
                                                    {finding.type === "WEAKNESS" && <Icon type="close-circle" theme="filled" />}
                                                    {finding.type === "WARNING" && <Icon type="warning" theme="filled" />}
                                                    <span dangerouslySetInnerHTML={{ __html: finding.content }} />
                                                </li>
                                            ))}
                                        </ul>

                                        <div className="score">Score: {section.score}/10</div>
                                    </div>
                                ))}
                            </div>
                        </Col>

                        <Col span={10} className="opportunities-col">
                            <h4 className="opportunities-title">Content Opportunities</h4>
                            <ul className="content-opportunities">
                                {contentOpportunities.map((opportunity, index) => (
                                    <li key={index}>
                                        <div className="opportunity-title" dangerouslySetInnerHTML={{ __html: `${index + 1}. ${opportunity.title}` }}></div>
                                        <div className="opportunity-description" dangerouslySetInnerHTML={{ __html: opportunity.description }}></div>
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                </>
            )}
        </Card>
    );
}